import styled from 'react-emotion'

export const GallerySection = styled('div')`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
`

export const GalleryHeader = styled('div')`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-end;
`

export const GalleryBody = styled('div')`
  height: 100%;
  background-color: transparent;
  margin: 20px 50px 10px 50px;
  display-flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    margin: 20px 20px 10px 20px;
  }
  
`

export const GalleryFooter = styled('div')`
  height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 767px) {
    height: 250px;
  }
`

export const FooterText = styled('div')`
  display: flex;
  align-items: center;
  font-family: din-2014;
  color: #ffffff;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  font-size: 1em;
`

export const GalleryFooterDescription = styled(FooterText)`
  display: flex;
  justify-content: center;
  opacity: 0.8;
  line-height: 1.56;
  width: 83%;
`

export const GalleryFooterDate = styled(FooterText)`
  opacity: 0.7;
  font-size: 0.875em;
  line-height: 1.79;
`

export const GalleryCloseIconContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-top: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  cursor: pointer;
  object-fit: contain;

  &:hover {
    fill-color: white;
  }
`

export const GalleryFooterHorizontalLine = styled('div')`
  width: 83%;
  background-color: #ffffff;
  height: 2px;
  opacity: 0.5;
  margin-top: 10px;
`
export const GalleryNavigationContainerRight = styled(`div`)`
  position: absolute;
  right: 0;
  top: calc(50vh - 50px);
  width: 1.5em;
  height: 1.5em;
  margin-right: 1.25em;
  object-fit: contain;
  cursor: pointer;
  @media (max-width: 767px) {
    top: calc(50vh - 75px);
    margin-right: 0.5em;
  }
`
export const GalleryNavigationContainerLeft = styled(`div`)`
  position: absolute;
  width: 1.5em;
  height: 1.5em;
  object-fit: contain;
  margin-left: 1.25em;
  left: 0;
  top: calc(50vh - 50px);
  cursor: pointer;
  @media (max-width: 767px) {
    top: calc(50vh - 75px);
    margin-left: 0.5em;
  }
`

export const ImageContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/Home/GalleryHome/styledComponents.js